<template>
  <v-app>
    <router-view @show-alert="showAlert"/>
    <alert-snackbar ref="alert"/>
  </v-app>
</template>

<script>
import AlertSnackbar from './components/shared/AlertSnackbar.vue';

export default {
  name: 'App',
  components: {
    AlertSnackbar
  },
  methods: {
    showAlert(options) {
      this.$refs.alert.showAlert(options);
    }
  }
};
</script>
